// extracted by mini-css-extract-plugin
export default {"progress":"styles_progress__iP2lP","form":"styles_form__Vz7Ve","resend":"styles_resend__F4T20"};